var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardBrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.63299 20.2602C5.63299 20.2602 -0.207395 36.4835 10.2021 35.043C20.6115 33.6025 35.8199 44.7766 37.4906 31.1672C39.1632 17.5579 36.6224 5.20845 31.2508 3.94662C25.8792 2.68479 12.4766 -0.444931 5.63299 20.2602Z",
    fill: "#B49D70",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3335 10.3337C27.5735 10.3337 28.1934 10.3337 28.7021 10.47C30.0825 10.8398 31.1607 11.918 31.5305 13.2984C31.6668 13.807 31.6668 14.427 31.6668 15.667V27.9337C31.6668 30.1739 31.6668 31.294 31.2309 32.1496C30.8474 32.9023 30.2354 33.5142 29.4828 33.8977C28.6271 34.3337 27.507 34.3337 25.2668 34.3337H16.7335C14.4933 34.3337 13.3732 34.3337 12.5175 33.8977C11.7649 33.5142 11.153 32.9023 10.7695 32.1496C10.3335 31.294 10.3335 30.1739 10.3335 27.9337V15.667C10.3335 14.427 10.3335 13.807 10.4698 13.2984C10.8397 11.918 11.9179 10.8398 13.2982 10.47C13.8069 10.3337 14.4269 10.3337 15.6668 10.3337M17.0002 25.0003L19.6668 27.667L25.6668 21.667M17.8002 13.0003H24.2002C24.9469 13.0003 25.3203 13.0003 25.6055 12.855C25.8564 12.7272 26.0603 12.5232 26.1882 12.2723C26.3335 11.9871 26.3335 11.6137 26.3335 10.867V9.80033C26.3335 9.05359 26.3335 8.68022 26.1882 8.395C26.0603 8.14412 25.8564 7.94015 25.6055 7.81232C25.3203 7.66699 24.9469 7.66699 24.2002 7.66699H17.8002C17.0534 7.66699 16.6801 7.66699 16.3948 7.81232C16.144 7.94015 15.94 8.14412 15.8122 8.395C15.6668 8.68022 15.6668 9.05359 15.6668 9.80033V10.867C15.6668 11.6137 15.6668 11.9871 15.8122 12.2723C15.94 12.5232 16.144 12.7272 16.3948 12.855C16.6801 13.0003 17.0534 13.0003 17.8002 13.0003Z",
    stroke: "#3F2C26",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardBrown);
export default __webpack_public_path__ + "static/media/clipboard-brown.dadd397bf207517b13858b8f6e529319.svg";
export { ForwardRef as ReactComponent };